"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class GraphicMode {
    constructor(id, width, height) {
        this.pixelWidth = 1;
        this.pixelHeight = 1;
        this.rowsPerCell = 8;
        this.bytesPerCellRow = 1;
        this.fliBugSize = 0;
        this.indexMap = {
            0: 0,
            1: 1,
            2: 2,
            3: 3
        };
        this.id = id;
        this.width = width;
        this.height = height;
    }
    pixelsPerByte() {
        return 8 / this.pixelWidth;
    }
    pixelsPerCellRow() {
        return this.bytesPerCellRow * this.pixelsPerByte();
    }
    forEachCellRow(cellY, callback) {
        for (let rowY = cellY; rowY < cellY + this.rowsPerCell; rowY += 1) {
            callback(rowY);
        }
    }
    forEachCell(yOffset, callback) {
        const pixelsPerCellRow = this.pixelsPerCellRow();
        for (let y = yOffset; y < this.height; y += this.rowsPerCell) {
            for (let x = 0; x < this.width; x += pixelsPerCellRow) {
                callback(x, y);
            }
        }
    }
    forEachByte(cellX, callback) {
        const pixelsPerByte = this.pixelsPerByte();
        for (let byteX = cellX; byteX < cellX + this.bytesPerCellRow * pixelsPerByte; byteX += pixelsPerByte) {
            callback(byteX);
        }
    }
    forEachPixel(byteX, callback) {
        const pixelsPerByte = this.pixelsPerByte();
        for (let pixelX = 0; pixelX < pixelsPerByte; pixelX += 1) {
            const shiftTimes = (pixelsPerByte - 1 - pixelX) * this.pixelWidth;
            callback(byteX + pixelX, shiftTimes);
        }
    }
}
exports.default = GraphicMode;
//# sourceMappingURL=GraphicMode.js.map